<template>
	<div class="p4">
		<div class="xs-12 wrap">
			<core-form-input
				componentName="j-base-select"
				name="factOptions"
				:label="$t('fact_type')"
				:options="options"
				v-model="form.factOptions"
				v-validate="'required'"
				class="mb6"
				@input="initInputValue"
			/>

			<core-form-input
				componentName="j-base-input-text"
				name="type"
				:label="$t('fact_label')"
				v-model="form.type"
				v-validate="'required'"
				class="mb6"
			/>

			<core-form-input
				componentName="j-base-toggle"
				name="type"
				:label="$t('value')"
				v-model="form.value"
				v-validate="'required'"
				v-if="form.factOptions === 'booleanValue'"
			/>

			<core-form-input
				componentName="j-base-date-picker-simple"
				name="type"
				:label="$t('value')"
				v-model="form.value"
				v-validate="'required'"
				v-if="form.factOptions === 'dateValue'"
			/>

			<core-form-input
				componentName="j-base-input-number"
				name="type"
				:label="$t('value')"
				v-model="form.value"
				v-validate="'required'"
				v-if="form.factOptions === 'numberValue'"
			/>

			<core-form-input
				componentName="j-input-list"
				name="type"
				:label="$t('value')"
				v-model="form.value"
				v-validate="'required'"
				v-if="form.factOptions === 'arrayValue'"
			/>

			<core-form-input
				componentName="j-base-input-text"
				name="type"
				:label="$t('value')"
				v-model="form.value"
				v-validate="'required'"
				v-if="form.factOptions === 'stringValue'"
			/>

			<!-- Buttons -->
			<div class="xs-12 mt4">
				<j-button :isLoading="isLoading" @click="handleSubmit">
					{{ type === "add" ? $t("add") : $t("update") }}
				</j-button>
			</div>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	name: "FactForm",
	components: {
		JButton,
		CoreFormInput
	},
	props: {
		type: {
			required: true,
			type: String
		},
		isLoading: Boolean,
		initValues: Object
	},
	data() {
		return {
			form: {},
			options: [
				{ name: "Text", value: "stringValue" },
				{ name: "Number", value: "numberValue" },
				{ name: "Boolean", value: "booleanValue" },
				{ name: "Date", value: "dateValue" },
				{ name: "List", value: "arrayValue" }
			]
		}
	},

	mounted() {
		this.initialize()
	},

	methods: {
		handleSubmit() {
			const input = {
				type: this.form.type,
				value: {
					[this.form.factOptions]: this.form.value
				}
			}

			this.$emit("submit", input)
		},

		initInputValue() {
			if (this.form.factOptions === "booleanValue") this.form.value = false
			else delete this.form.value
		},

		initialize() {
			if (this.type === "add") return

			this.form = {
				factOptions: this.initValues.factOptions,
				type: this.initValues.type,
				value: this.initValues.value
			}
		}
	}
}
</script>
